"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onDropDownFilter = exports.SearchableDropDown = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactVirtual = require("react-virtual");
var _FooterFilter = _interopRequireDefault(require("./FooterFilter"));
var _SearchTextFilter = _interopRequireDefault(require("./SearchTextFilter"));
var _ykbUtils = require("ykb-utils");
var _TextInput = _interopRequireDefault(require("../../../TextInput"));
var _Icon = _interopRequireDefault(require("../../../Icon"));
var _Menu = _interopRequireDefault(require("../../../Menu"));
var _Checkbox = _interopRequireDefault(require("../../../Checkbox"));
var _Radio = require("../../../Radio");
var _Tooltip = _interopRequireDefault(require("../../../Tooltip"));
var _excluded = ["data", "multiple", "prefixCls", "query", "domNode", "dataIndex", "useVirtualRender"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MenuItem = _Menu.default.Item;
var generateDropDownDataArray = function generateDropDownDataArray(tableData, dataIndex) {
  var valueList = [];
  return tableData.reduce(function (acc, item) {
    var value = item[dataIndex];
    var data = {
      value: value,
      text: value
    };
    var isExist = valueList.indexOf(data.value) > -1;
    if (!isExist) {
      acc.push(data);
      valueList.push(data.value);
    }
    return acc;
  }, []);
};
var SearchableDropDownMenu = function SearchableDropDownMenu(_ref) {
  var _virtualRows$, _virtualRows;
  var data = _ref.data,
    multiple = _ref.multiple,
    prefixCls = _ref.prefixCls,
    query = _ref.query,
    domNode = _ref.domNode,
    dataIndex = _ref.dataIndex,
    useVirtualRender = _ref.useVirtualRender,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _React$useState = _react.default.useState(data),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    dataList = _React$useState2[0],
    setDataList = _React$useState2[1];
  var _useState = (0, _react.useState)(rest.selectedKeys || []),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedKeys = _useState2[0],
    setSelectedKeys = _useState2[1];
  var ckRef = (0, _ykbUtils.containerChecker)(document);
  var menuRef = (0, _react.useRef)(null);
  var rowVirtualizer = (0, _reactVirtual.useVirtual)({
    parentRef: menuRef,
    size: dataList.length,
    overscan: 2,
    horizontal: false
  });
  var virtualItems = rowVirtualizer.virtualItems,
    totalSize = rowVirtualizer.totalSize;
  var virtualRows = virtualItems;
  var paddingTop = virtualRows.length > 0 ? (virtualRows === null || virtualRows === void 0 ? void 0 : (_virtualRows$ = virtualRows[0]) === null || _virtualRows$ === void 0 ? void 0 : _virtualRows$.start) || 0 : 0;
  var paddingBottom = virtualRows.length > 0 ? totalSize - ((virtualRows === null || virtualRows === void 0 ? void 0 : (_virtualRows = virtualRows[virtualRows.length - 1]) === null || _virtualRows === void 0 ? void 0 : _virtualRows.end) || 0) : 0;
  (0, _react.useEffect)(function () {
    var filteredData = data;
    if (!!query) {
      filteredData = data.filter(function (item) {
        return (0, _SearchTextFilter.default)(item.text, query);
      });
      ckRef.querySelector("#ykb-ui-".concat(dataIndex, "-menu-wrapper ul")).scrollTo(0, 0);
    }
    setDataList(filteredData);
  }, [data, query]);
  (0, _react.useEffect)(function () {
    menuRef.current = ckRef === null || ckRef === void 0 ? void 0 : ckRef.querySelector("#ykb-ui-".concat(dataIndex, "-menu-wrapper ul"));
    setTimeout(function () {
      rowVirtualizer.measure();
    }, 0);
  }, []);
  (0, _react.useEffect)(function () {
    setSelectedKeys(rest.selectedKeys);
  }, [rest.selectedKeys]);
  var handleSelectedKeys = function handleSelectedKeys(_ref2) {
    var selectedKeys = _ref2.selectedKeys;
    setSelectedKeys(selectedKeys);
    rest.setSelectedKeys({
      selectedKeys: selectedKeys
    });
  };
  var handleRadioCheckboxClick = function handleRadioCheckboxClick(e) {
    e.stopPropagation();
    if (e.nativeEvent.stopImmediatePropagation) {
      e.nativeEvent.stopImmediatePropagation();
    }
  };
  var renderVirtualRow = function renderVirtualRow() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("li", {
      style: {
        height: "".concat(paddingTop, "px")
      }
    }), virtualRows.map(function (virtualRow) {
      var _item$value, _item$value2;
      var item = dataList[virtualRow.index];
      return /*#__PURE__*/_react.default.createElement(MenuItem, {
        key: item.value
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "dropdown-menu-item-content-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "dropdown-menu-item-radio-checkbox-wrapper"
      }, multiple ? /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        onClick: handleRadioCheckboxClick,
        checked: selectedKeys.indexOf(item === null || item === void 0 ? void 0 : (_item$value = item.value) === null || _item$value === void 0 ? void 0 : _item$value.toString()) >= 0
      }) : /*#__PURE__*/_react.default.createElement(_Radio.Radio, {
        onClick: handleRadioCheckboxClick,
        checked: selectedKeys.indexOf(item === null || item === void 0 ? void 0 : (_item$value2 = item.value) === null || _item$value2 === void 0 ? void 0 : _item$value2.toString()) >= 0
      })), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        placement: "right",
        overlay: item.text
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "dropdown-menu-item-text"
      }, item.text))));
    }), /*#__PURE__*/_react.default.createElement("li", {
      style: {
        height: "".concat(paddingBottom, "px")
      }
    }));
  };
  var renderRow = function renderRow() {
    return dataList.map(function (item) {
      var _item$value3, _item$value4;
      return /*#__PURE__*/_react.default.createElement(MenuItem, {
        key: item.value
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "dropdown-menu-item-content-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "dropdown-menu-item-radio-checkbox-wrapper"
      }, multiple ? /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        onClick: handleRadioCheckboxClick,
        checked: selectedKeys.indexOf(item === null || item === void 0 ? void 0 : (_item$value3 = item.value) === null || _item$value3 === void 0 ? void 0 : _item$value3.toString()) >= 0
      }) : /*#__PURE__*/_react.default.createElement(_Radio.Radio, {
        onClick: handleRadioCheckboxClick,
        checked: selectedKeys.indexOf(item === null || item === void 0 ? void 0 : (_item$value4 = item.value) === null || _item$value4 === void 0 ? void 0 : _item$value4.toString()) >= 0
      })), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        placement: "right",
        overlay: item.text
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "dropdown-menu-item-text"
      }, item.text))));
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "ykb-ui-".concat(dataIndex, "-menu-wrapper")
  }, /*#__PURE__*/_react.default.createElement(_Menu.default, {
    multiple: multiple,
    onSelect: handleSelectedKeys,
    onDeselect: handleSelectedKeys,
    selectedKeys: selectedKeys,
    getPopupContainer: function getPopupContainer(triggerNode) {
      return triggerNode.parentNode;
    },
    withoutStyle: true,
    prefixCls: prefixCls
  }, useVirtualRender ? renderVirtualRow() : renderRow()));
};
var SearchableDropDown = exports.SearchableDropDown = /*#__PURE__*/function (_Component) {
  function SearchableDropDown(props) {
    var _this;
    (0, _classCallCheck2.default)(this, SearchableDropDown);
    _this = _callSuper(this, SearchableDropDown, [props]);
    (0, _defineProperty2.default)(_this, "setSelectedKeys", function (_ref3) {
      var selectedKeys = _ref3.selectedKeys;
      _this.setState({
        selectedKeys: selectedKeys
      });
    });
    _this.state = {
      query: '',
      selectedKeys: props.selectedKeys || [],
      data: props.filters || generateDropDownDataArray(props.data, props.dataIndex)
    };
    _this.onTextChange = _this.onTextChange.bind(_this);
    _this.domNode = null;
    return _this;
  }
  (0, _inherits2.default)(SearchableDropDown, _Component);
  return (0, _createClass2.default)(SearchableDropDown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // this.domeNode = ReactDOM.findDOMNode(this);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.selectedKeys !== prevProps.selectedKeys) {
        this.setState({
          query: '',
          selectedKeys: this.props.selectedKeys || []
        });
      }
      if (prevProps.data !== this.props.data || prevProps.filters !== this.props.filters) {
        this.setState({
          data: this.props.filters || generateDropDownDataArray(this.props.data, this.props.dataIndex)
        });
      }
    }
  }, {
    key: "onTextChange",
    value: function onTextChange(e) {
      this.setState({
        query: e.target.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        setSelectedKeys = _this$props.setSelectedKeys,
        _confirm = _this$props.confirm,
        _clearFilters = _this$props.clearFilters,
        locale = _this$props.locale,
        multiple = _this$props.multiple,
        prefixCls = _this$props.prefixCls,
        dataIndex = _this$props.dataIndex,
        _this$props$useVirtua = _this$props.useVirtualRender,
        useVirtualRender = _this$props$useVirtua === void 0 ? true : _this$props$useVirtua;
      var _this$state = this.state,
        query = _this$state.query,
        selectedKeys = _this$state.selectedKeys,
        data = _this$state.data,
        domNode = _this$state.domNode;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "dropdown-container"
      }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        value: query,
        onChange: this.onTextChange,
        size: "small",
        suffix: /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: "search"
        })
      })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(SearchableDropDownMenu, {
        data: data,
        multiple: multiple,
        selectedKeys: selectedKeys,
        setSelectedKeys: this.setSelectedKeys,
        prefixCls: prefixCls,
        query: query,
        domNode: domNode,
        dataIndex: dataIndex,
        useVirtualRender: useVirtualRender
      })), /*#__PURE__*/_react.default.createElement(_FooterFilter.default, {
        locale: locale,
        confirm: function confirm() {
          setSelectedKeys(selectedKeys);
          _confirm();
        },
        clearFilters: function clearFilters() {
          _this2.setState({
            query: '',
            selectedKeys: []
          }, function () {
            setSelectedKeys([]);
            _clearFilters();
          });
        }
      }));
    }
  }]);
}(_react.Component);
var onDropDownFilter = exports.onDropDownFilter = function onDropDownFilter(dataIndex, value, record) {
  if (Array.isArray(value)) {
    return value.contains(record[dataIndex].toString());
  }
  return record[dataIndex] && record[dataIndex].toString() === value.toString();
};